import React from "react";
import { Popup } from "../../sharedComponents/popup/popup";
import { DatePicker } from "@material-ui/pickers";

interface FakeComponentsState {
  isOpen: boolean;
}

export default class FakeComponents extends React.Component<any, FakeComponentsState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isOpen: true
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ isOpen: false });
    }, 0);
  }

  public render() {
    return (
      <>
        <Popup className="fake-popup"
          open={this.state.isOpen}
          dialogContent={<></>}
        />
        <DatePicker
          open={this.state.isOpen}
          DialogProps={
            { className: "fake-dialog-props" }}
          value={new Date()}
          onChange={() => true}
          className="fake-data-picker"
        />
      </>
    );
  }
}
